import VizAuth from "@/components/auth/auth.jsx";
import ForgotPassword from "@/components/auth/forgot-password.jsx";
import AuthWidget from "@/components/auth/login.jsx";
import SetNewPassword from "@/components/auth/set-new-password.jsx";
import SignUp from "@/components/auth/sign-up.jsx";
import Callback from "@/routes/callback.jsx";
import "@/index.css";
import {
  AccountSettings,
} from "@/routes/account-settings.jsx";
import Error from "@/routes/error.jsx";
import Overview from "@/routes/overview/overview.jsx";
import Projects from "@/routes/projects/projects.jsx";
import Root from "@/routes/root.jsx";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    title: "Overview",
    children: [
      {
        path: "/",
        element: <Overview />,
        title: "Overview",
      },
      {
        path: "/overview",
        element: <Overview />,
        title: "Overview",
      },
      {
        path: "/projects",
        element: <Projects />,
        title: "Projects",
      },
      // {
      //   path: "/settings",
      //   element: <SettingsPage />,
      // },
      {
        path: "/settings/account",
        element: <AccountSettings />,
        title: "Account",
      },
    ],
    errorElement: <Error />,
  },
  {
    path: "auth",
    element: <VizAuth />,
    children: [
      { path: "login", element: <AuthWidget /> },
      { path: "sign-up", element: <SignUp /> },
      { path: "forgot-password", element: <ForgotPassword /> },
    ],
  },
  { path: "new-password", element: <SetNewPassword /> },
  { path: "callback", element: <Callback /> },
]);

export default router;
